import { inject, Injectable, signal } from '@angular/core';
import { ApiService, IEcoupon } from '@web-nx-ng-tsc/campaign-shared-data-access';
import { tap } from 'rxjs';
import { LoggingService } from '@web-nx-ng-tsc/util-logging';

@Injectable({
  providedIn: 'root',
})
export class FormEcouponService {
  private readonly apiService = inject(ApiService);
  private readonly loggingService = inject(LoggingService);

  // provinceListSignal = this.apiService.getProvinceListSignal();
  private readonly provinceListSignal = signal<any>(undefined);
  // private readonly errorMessageSignal = signal<any>(undefined);
  private readonly passForm = signal<boolean>(false);

  // errMsg = this.formEcouponService.getErrorMessageSignal();

  getpassFormSignal() {
    // this.loggingService.log('errorMessageSignal', this.errorMessageSignal());
    return this.passForm;
  }

  private dataFormSignal = signal<any>(undefined);
  getDataFormSignal() {
    this.loggingService.log('get', this.dataFormSignal());

    return this.dataFormSignal;
  }
  setDataFormSignal(data: IEcoupon) {
    this.dataFormSignal.set(data);
  }
  setPassFormSignal(value: any) {
    this.passForm.set(value);
  }

  clearDataFormSignal() {
    this.dataFormSignal.set(undefined);
  }

  getProvinceListSignal() {
    return this.provinceListSignal;
  }
  getProvince() {
    return this.apiService.getProvince().pipe(tap((res) => this.provinceListSignal.set(res)));
  }
  // getDetailCampaign(id: string) {
  //   return this.apiService.getDetailCampaign(id).pipe(
  //     tap((res: any) => {
  //       if (res) {
  //         this.loggingService.log('tap |getDetailCampaign', res);
  //         //   if (res.ok == 1) {
  //         //     this.loggingService.log('getDetailCampaign', res);
  //         //   }
  //         // } else {
  //         //   this.errorMessageSignal.set(res.msg);
  //         //   this.errorStatus.set(res.error);
  //       }
  //     })
  //   );
  // }
}
